/** User-facing label for `broker_name: custom_csv` (capabilities may still return the legacy name). */
export const CUSTOM_CSV_BROKER_DISPLAY_NAME = "Other broker";

export function isCustomCsvBrokerName(brokerName: string): boolean {
  return brokerName.trim().toLowerCase() === "custom_csv";
}

export function resolveBrokerDisplayName(
  cap: { broker_name?: string; display_name?: string } | null | undefined
): string {
  if (cap && isCustomCsvBrokerName(cap.broker_name ?? "")) {
    return CUSTOM_CSV_BROKER_DISPLAY_NAME;
  }
  return cap?.display_name?.trim() || cap?.broker_name?.trim() || "Broker";
}

/** User-facing broker + account labels for custom_csv trade-account rows. */
export function resolveCustomCsvTradeAccountLabels(row: {
  display_name?: string | null;
  label?: string | null;
  account_code: string;
  executing_broker_name?: string | null;
  executingBrokerName?: string | null;
}): { brokerDisplayName: string; tradeLabel: string } {
  const brokerDisplayName = CUSTOM_CSV_BROKER_DISPLAY_NAME;
  const executing = String(row.executing_broker_name ?? row.executingBrokerName ?? "").trim();
  const trimmedLabel = String(row.label ?? "").trim();
  const accountCode = String(row.account_code ?? "").trim();

  if (executing && accountCode) {
    return { brokerDisplayName, tradeLabel: `${executing} – ${accountCode}` };
  }

  if (trimmedLabel) {
    const lanePrefix = String(row.display_name ?? "").trim();
    if (lanePrefix && trimmedLabel.toLowerCase().startsWith(lanePrefix.toLowerCase())) {
      const suffix = trimmedLabel.slice(lanePrefix.length).replace(/^\s*[–-]\s*/, "");
      return {
        brokerDisplayName,
        tradeLabel: suffix ? `${brokerDisplayName} – ${suffix}` : brokerDisplayName,
      };
    }
    return { brokerDisplayName, tradeLabel: trimmedLabel };
  }

  return {
    brokerDisplayName,
    tradeLabel: accountCode ? `${brokerDisplayName} – ${accountCode}` : brokerDisplayName,
  };
}
